// Échappement CSS partagé (sélecteurs d'attributs). Utilise `CSS.escape` quand
// disponible, avec un repli minimal pour les environnements anciens.
export function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
        return window.CSS.escape(value);
    }
    return String(value).replace(/["\\\]]/g, "\\$&");
}
